import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=a805018c&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
import style0 from "./Users.vue?vue&type=style&index=0&id=a805018c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805018c",
  null
  
)

export default component.exports